export default __webpack_public_path__ + "alert-small.a0e3f0ee98f4b118.svg";